import { Article } from '../types';
import { ArticleRepository } from '../utils/repository';

class ArticlesByTopics extends ArticleRepository<Article> {
  getManyPaginated(page: Ref<number>, topicId: string) {
    return this._getManyPaginated({ url: `/topics/${topicId}/articles` });
  }
}

export const articlesByTopicsRepository = new ArticlesByTopics();
